'use strict'

Vue.component('awe-list', {
  props:{
    items: {type: Array, required: true}, // [{value: String, selected: Boolean}]
    type: {type: String, default: 'checkbox'},
  },
  methods:{
    handleClick(item) {
      this.$emit('change', item)
    }
  },
  template: `
    <div class="list-container">
      <div v-for="item in items" :class="{'list-item': true, 'checked-item': item.selected}">
        <label :aria-label="item.displayValue || item.value" :title="item.displayValue || item.value"> 
          <input 
            :type="type"
            v-model="item.selected" :value="item.value" 
            @change="handleClick(item)"
            :aria-selected="!!item.selected"
          >
          {{ item.displayValue || item.value }} 
        </label>
      </div>
    </div>
  `
})
